export const noddiColors = {
  darkPurple: '#35155A',
  darkPurple90: '#492C6B',
  darkPurple80: '#5D447B',
  darkPurple70: '#725B8B',
  darkPurple60: '#86739C',
  darkPurple50: '#9A8AAC',
  darkPurple40: '#D7D0DE',
  darkPurple30: '#EBE8EE',

  noddiPurple: '#8661C1',
  noddiPurple90: '#6D48A7',
  noddiPurple80: '#532E8E',
  noddiPurple70: '#3A1575',
  noddiPurple60: '#20005B',
  noddiPurple50: '#070042',
  noddiPurple40: '#000028',
  noddiPurple30: '#00000F',

  noddiPink: '#FFC7ED',
  noddiPink90: '#FFCDEF',
  noddiPink80: '#FFD2F1',
  noddiPink70: '#FFD8F2',
  noddiPink60: '#FFDDF4',
  noddiPink50: '#FFE3F6',
  noddiPink40: '#FFE9F8',
  noddiPink30: '#FFEEFA',

  noddiOrange: '#FF4521',

  white: '#FFFFFF',
  white60: 'rgba(255, 255, 255, 0.6)',
  black: '#000000',
  black10: '#1F1F1F',
  silverGray: '#DADDE0',
  lightPurple: '#EDE5FD',

  raspberry: '#C738BD',
  raspberry90: '#CD4CC4',
  raspberry80: '#D260CA',
  raspberry70: '#D874D1',
  raspberry60: '#DD88D7',
  raspberry50: '#E39BDE',
  raspberry40: '#E9AFE5',
  raspberry30: '#EEC3EB',
  // Ink for raspberry surfaces: raspberry itself reads 3.87:1 on raspberryBg and every step
  // above it is lighter, so small text on the mobile channel badge needs a darker one.
  raspberryDark: '#8E1F86',

  coral: '#FFEAE5',
  coral90: '#FFECE8',
  coral80: '#FFEEEA',
  coral70: '#FFF0ED',
  coral60: '#FFF2EF',
  coral50: '#FFF5F2',
  coral40: '#FFF7F5',
  coral30: '#FFF9F7',

  noddiOrange50: '#BB3018',

  grey: '#7C7B7D',
  snow: '#FFFAFA',
  greyMuted: '#717182',

  // Brand tint behind icon tiles and the screen wash; not a text surface.
  purpleBg: '#F3EFF9',

  darkPurpleGrey: '#F7F6FA',
  darkPurpleBg: '#F7F7F7',
  raspberryBg: '#F9EBF8',
  darkRaspberry: '#ECDEFB',
  pinkBg: '#FFF4FB',

  outlineStroke: '#EDEEEF',
  transparent: 'transparent',
  success: '#128667',
  success50: '#A0CFC2',
  success20: '#D0E8E2',
  successDark: '#0A5947',

  warning: '#D78E01',
  warning50: '#FFFADE',
  warningDark: '#7A4F00',

  danger: '#EA5147',
  danger50: '#FBDCDA',
  dangerDark: '#992C25',

  // Status: in progress. Ink on blue50, like the other *Dark status inks on their tints.
  info: '#2563EB',
  blue50: '#EFF6FF',
  infoDark: '#1E40AF',

  // Tire season tints (worker `NativeNavioTireSeasonChip`, web `NavioTireSeasonChip`, mirrored in noddi-ui-web
  // index.css). They name a season, not a status, so they stay apart from info/warning/success. Ink on its tint >= 4.5:1.
  winterBg: '#EAF0FE',
  winterInk: '#2A5BD7',
  summerBg: '#FFF3D6',
  summerInk: '#9A6400',
  allSeasonBg: '#D0E8E2',
  allSeasonInk: '#0A5947',

  // iOS inset-grouped surfaces (worker app). Primary text stays black10.
  // labelSecondary is darker than iOS secondaryLabel so meta text keeps ~5:1 outdoors.
  labelSecondary: '#6C6C70',
  labelTertiary: 'rgba(60, 60, 67, 0.3)',
  // iOS UIColor.separator (light): a hairline that still reads outdoors.
  separator: 'rgba(60, 60, 67, 0.29)',
  // Brand-tinted grouped background. Section headers sit on it in labelSecondary, so keep that pair at >= 4.5:1 (4.56 now).
  groupedBackground: '#F1EEF7',
  // Pressed row: darker than groupedBackground, or a held row reads as a hole in its white group.
  pressedFill: '#DAD5E3',
  // Selected option card (`SelectableTileCard`): purpleBg is ~1:1 with groupedBackground, so a selected card read as a
  // hole in the screen. This one stays apart from groupedBackground, white and the season tints.
  selectedFill: '#E8DEFA',
  // Empty part of a progress track or stepper; ~1.7:1 on groupedBackground, 2:1 on white (iOS systemFill is ~1.3).
  progressTrack: '#BFB6CC'
} as const;
